import { createConsumer } from '@rails/actioncable'

let consumer = null

function getConsumer() {
  if (!consumer) {
    consumer = createConsumer('/properties/cable')
  }
  return consumer
}

export function subscribeTo(chatId, onData) {
  const c = getConsumer()
  const subscription = c.subscriptions.create(
    { channel: 'GuestChatChannel', chat_id: chatId },
    { received: onData }
  )
  return subscription
}

export function unsubscribe(subscription) {
  if (subscription) {
    subscription.unsubscribe()
  }
}

export function disconnectConsumer() {
  if (consumer) {
    consumer.disconnect()
    consumer = null
  }
}
